export default "/images/ArturAdamczyk.jpg?f20b51985880190d594cd773e00df5f6";